var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoChartDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.726,
    height: 54,
    viewBox: "0 0 43.726 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    "data-name": "Group 1796",
    transform: "translate(-7.3 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M43.016,5.97V48.547H12.04v3.385H46.4V5.97Z",
    transform: "translate(-0.708 -0.706)",
    fill: "#f0f4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M16.8,2.04,8.11,10.732V48H42.471V2.04Z",
    transform: "translate(-0.121 -0.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 12.307,
    cy: 12.307,
    r: 12.307,
    transform: "translate(15.482 19.698)",
    fill: "#eff3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M36.063,42.093a8.793,8.793,0,1,1,0-12.435A8.8,8.8,0,0,1,36.063,42.093Z",
    transform: "translate(-2.056 -3.862)",
    fill: "#eff3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M44.133,48.1,42.39,46.36a11.689,11.689,0,0,1-2.05,2.05l1.744,1.744a2.736,2.736,0,0,0,.723,2.526l7.85,7.85a2.724,2.724,0,0,0,3.853-3.853l-7.85-7.85A2.736,2.736,0,0,0,44.133,48.1Z",
    transform: "translate(-4.939 -6.743)",
    fill: "#eff3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M16.752,10.682V1.99L8.06,10.682Z",
    transform: "translate(-0.114 -0.111)",
    fill: "#eff3f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1796-2",
    "data-name": "Group 1796",
    transform: "translate(7.3 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M36.388,29.084a9.441,9.441,0,1,0,0,13.353A9.386,9.386,0,0,0,36.388,29.084Zm-.9,12.452a8.165,8.165,0,1,1,0-11.55A8.112,8.112,0,0,1,35.486,41.536Z",
    transform: "translate(-9.239 -4.997)",
    fill: "#303763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M51.353,52.647l-7.859-7.867a3.374,3.374,0,0,0-2.764-.961L39.6,42.687a12.964,12.964,0,1,0-2.951,2.951l1.131,1.131a3.32,3.32,0,0,0,.961,2.756L46.6,57.393a3.368,3.368,0,0,0,5.75-2.381,3.394,3.394,0,0,0-1-2.364ZM20.827,43.4a11.679,11.679,0,1,1,16.517,0,11.7,11.7,0,0,1-16.517,0ZM50.451,56.5a2.084,2.084,0,0,1-2.951,0l-7.859-7.859a2.083,2.083,0,0,1-.553-1.939.625.625,0,0,0-.17-.587l-1.25-1.25a.178.178,0,0,0,.034-.051c.187-.17.383-.323.561-.51s.332-.366.5-.553c.017-.017.043-.026.051-.043l1.25,1.25a.625.625,0,0,0,.587.17,2.089,2.089,0,0,1,1.939.553l7.859,7.867a2.084,2.084,0,0,1,0,2.951Z",
    transform: "translate(-8.622 -4.379)",
    fill: "#303763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M34.387,33.027a.642.642,0,0,0-.9,0l-2.8,2.8-2.8-2.8a.637.637,0,0,0-.9.9l2.8,2.807-2.8,2.8a.642.642,0,0,0,0,.9.637.637,0,0,0,.9,0l2.8-2.8,2.8,2.8a.637.637,0,0,0,.9,0,.642.642,0,0,0,0-.9l-2.8-2.8,2.8-2.807a.642.642,0,0,0,0-.9Z",
    transform: "translate(-10.215 -5.972)",
    fill: "#303763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M23.808,6.976H39.925a.638.638,0,0,0,0-1.276H23.808a.638.638,0,0,0,0,1.276Z",
    transform: "translate(-9.672 -1.915)",
    fill: "#303763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M39.932,9.67H23.8a.638.638,0,1,0,0,1.276H39.932a.638.638,0,0,0,0-1.276Z",
    transform: "translate(-9.671 -2.509)",
    fill: "#303763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M41.279,13.68H32.808a.638.638,0,1,0,0,1.276h8.471a.638.638,0,0,0,0-1.276Z",
    transform: "translate(-11.017 -3.108)",
    fill: "#303763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M41.279,17.68H32.808a.638.638,0,1,0,0,1.276h8.471a.638.638,0,0,0,0-1.276Z",
    transform: "translate(-11.017 -3.706)",
    fill: "#303763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M39.586,50.657H11.969V48.548H36.2a.638.638,0,0,0,0-1.276H8.576V11.227h8.063a.643.643,0,0,0,.638-.638V2.526H41.7V39.439a.638.638,0,0,0,1.276,0V5.911h2.109v36.6a.638.638,0,1,0,1.276,0V5.273a.643.643,0,0,0-.638-.638H42.98V1.888a.643.643,0,0,0-.638-.638H16.647a.637.637,0,0,0-.451.187l-8.709,8.7a.637.637,0,0,0-.187.451V47.9a.643.643,0,0,0,.638.638h2.747v2.747a.643.643,0,0,0,.638.638H39.578a.643.643,0,0,0,.638-.638A.628.628,0,0,0,39.586,50.657ZM16.009,3.427V9.951H9.477Z",
    transform: "translate(-7.3 -1.25)",
    fill: "#303763"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChartDataFound);
export default __webpack_public_path__ + "static/media/noChartDataFound.ab104a829dbf962977365e91fd0d511b.svg";
export { ForwardRef as ReactComponent };